// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_gv-0";
export var optionCard = "_gv-1";